/**
 * Single place for API origin vs /api prefix so axios and full-page OAuth redirects stay in sync.
 * REACT_APP_API_URL may be either https://api.host or https://api.host/api
 */

export function normalizeApiBaseUrl(rawUrl) {
  const fallback = 'http://localhost:8000/api';
  const value = (rawUrl || '').trim();
  if (!value) return fallback;

  const trimmed = value.replace(/\/+$/, '');
  if (trimmed.endsWith('/api')) return trimmed;
  return `${trimmed}/api`;
}

/** Origin only (no /api suffix) — use for window.location redirects to /api/auth/... */
export function getBackendOrigin(rawUrl) {
  return normalizeApiBaseUrl(rawUrl).replace(/\/api\/?$/, '');
}
